import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class TccDetailService {

  private BASE_URL:string = window["cfgApiBaseUrl"];
  private TCC_DATA_URL:string = this.BASE_URL+"tccdata";
  private TCC_PURPOSE_URL:string = this.BASE_URL+"purpose";
  private _tccdetail: ITccDetail;
  private _user : any;
  loggedInStatus = false;
  constructor(private http : HttpClient, private authservice: AuthService) { }

  public get tccdetail(): ITccDetail {
    return this._tccdetail;
  }

  public get user(): any {
    return this.authservice.getCurrentUser();
  }
  
  public getTccDetails():Observable<any>{
    return this.http.get<any>(this.TCC_DATA_URL+"?usergroup="+this.user.usergroup+"&division="+this.user.division+"&team_no="+this.user.team+"&username="+this.user.sub)
                    .pipe(
                          tap(r => { }),
                          catchError(this.errorHandler)
                         );
  }
 
  public getTccDetailsByTccno(tccno : string):Observable<any>{
    return this.http.get<any>(this.TCC_DATA_URL+"/"+tccno).pipe(
      map( res =>{
        this._tccdetail = res;
        return true;
      }),
      catchError(this.errorHandler));
  }

  public register(taxpayer : ITaxpayer){
    return this.http.post<any>(this.TCC_DATA_URL, taxpayer);
  }

  public  updateTccStatus(req:Istatus){
    return this.http.put<any>(this.TCC_DATA_URL,req);
  }

  public getPurpose():Observable<any>{
    return this.http.get<any>(this.TCC_PURPOSE_URL);

  }
  public getPurposeById(id : number):Observable<any>{
    return this.http.get<any>(this.TCC_PURPOSE_URL+"/"+id)
  }

  errorHandler(error : HttpErrorResponse){
    return observableThrowError(error.message || "Server Error");
  }
}
